import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'; // Bootstrap dosyasını dahil ediyoruz
import './styles/Education.css';

const EducationItem = ({ logo, school, degree, date, description }) => (
	<section className="mb-4">
		<div className="education-form-header row align-items-center">
			<div className="logo-and-school col-3 col-sm-2">
				<img src={logo} alt={school} className="img-fluid" />
				<h4>{school}</h4>
			</div>
			<div className="col-9 col-sm-10">
				<p>{degree}</p>
				<p>{date}</p>
			</div>
		</div>
		{description && <p className="lead">{description}</p>}
	</section>
);

const Education = () => {
	return (
		<div className="container" id="education-container">
			<div className="education-list">
				<div className="education-form">
					<EducationItem
						logo="https://cdn-images-1.medium.com/max/1200/1*69RcxrWXuk385lSxkIYYLA.png"
						school="Ironhack"
						degree="Full-Stack Web Development"
						date="December, 2023"
						description="Successfully graduated from a dynamic 2-month web development bootcamp with a focus on the MERN (MongoDB, Express.js, React, Node.js) stack. Developed proficiency in HTML, CSS, and JavaScript, along with specialized training in creating dynamic web applications using Node.js. Excited to leverage these skills in contributing to impactful projects and furthering my career in web development."
					/>
					<EducationItem
						logo="https://upload.wikimedia.org/wikipedia/en/2/27/Dokuz_Eylul_University_logo.png"
						school="Dokuz Eylul University"
						degree="Maritime Business & Administration, Bachelor"
						date="June, 2015"
					/>
				</div>
			</div>
		</div>
	);
};

export default Education;
